module.exports = __webpack_public_path__ + "img/aboutUs32.891b00b6.png";